export const postTableOption = {
    // 帖子列表信息
    page:false,
    border: true,
    stripe: true,
    align:'center',
    menuAlign:'center',
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    addBtn: false,
    searchShow: false,
    searchBtn: false,
    column: [{
      label: '标题',
      width: 260,
      prop: 'title',
      overHidden: true,
      solt: true,
      align: 'center'
    }, {
      label: '类别',
      prop: 'tagName',
      align: 'center',
      width: 110,
    }, {
      label: '圈子',
      width: 160,
      prop: 'circleName',
      solt: true,
      align: 'center'
    }, {
      label: '发布者',
      width: 200,
      prop: 'postedByName',
      solt: true,
      align: 'center',
    }, {
      // 0 = 草稿，1 = 已发布
      label: '发布状态',
      width: 110,
      prop: 'publishStatus',
      align: 'center',
    }, {
      label: '主题',
      width: 110,
      prop: 'themeTagName',
      align: 'center',
    }, {
      label: '评论',
      prop: 'commentCount',
      solt: true,
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      label: '收藏',
      prop: 'favoriteCount',
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      label: '点赞',
      prop: 'likeCount',
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      label: '浏览量',
      prop: 'viewedCount',
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      label: '初始热度值',
      prop: 'manualHeatValue',
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      label: '计算热度值',
      prop: 'autoHeatValue',
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      label: '热度值',
      prop: 'finalHeatValue',
      sortable: true,
      align: 'center',
      width: 110,
    }, {
      // isBanned 是否被下架
      // 0 = 正常 1 = 下架
      label: '状态',
      width: 110,
      prop: 'status',
      align: 'center'
    }, {
      // top 是否置顶
      label: '置顶',
      width: 110,
      prop: 'top',
      align: 'center'
    }, {
      label: '置顶排序',
      width: 110,
      prop: 'topPosition',
      sortable: true,
      align: 'center'
    }, {
      label: '过期',
      width: 110,
      prop: 'expired',
      align: 'center'
    }, {
      label:'评论开关',
      width: 100,
      type:'select',
      prop:'commentEnabled',
      solt: true,
      span:24,
      dicData: [{
        label: '关闭',
        value: false
      }, {
        label: '开启',
        value: true
      }]
    }, {
      // type: 'datetime',
      // valueFormat: 'timestamp',
      // format: 'yyyy-MM-dd hh:mm:ss',
      label: '发布时间',
      width: 180,
      prop: 'postTime',
      sortable: true,
      align: 'center'
    }, {
      // type: 'datetime',
      // valueFormat: 'timestamp',
      // format: 'yyyy-MM-dd hh:mm:ss',
      label: '修改时间',
      width: 180,
      prop: 'lastEditTime',
      sortable: true,
      align: 'center'
    }]
  }
